import { Request } from "helpers/request";
import { client } from "lib/sanity.client";
import { groq } from "next-sanity";
import filterDataToSingleItemForPreview from "helpers/filterDataToSingleItemForPreview";

export const getCaseList = async (params) => {
  return Request.call({
    url: "/case/",
    method: "GET",
    params,
  });
};

export const getCaseDbData = async (slug) => {
  return Request.call({
    url: `/case/${slug}`,
    method: "GET",
  });
};

export const getSlugs = async (params) => {
  return Request.call({
    url: `/slug/`,
    method: "GET",
    params,
  });
};

export const getPins = async (params) => {
  return Request.call({
    url: `/pin/`,
    method: "GET",
    params,
  });
};

export const getCasesByCoordinates = async (coordinates) => {
  return Request.call({
    url: `/case?coordinates=${coordinates}`,
    method: "GET",
  });
};

export const getRecommendations = async (slug) => {
  return Request.call({
    url: `/case/${slug}/recommendation`,
    method: "GET",
  });
};

export const getRegions = async () => {
  return Request.call({
    url: `/region`,
    method: "GET",
  });
};

export const getRegion = async (slug) => {
  return Request.call({
    url: `/region/${slug}`,
  });
};

export const getContent = async (slug) => {

  const query = groq`
    *[_type == 'case' && slug.current == $slug] {
        _id,
        "slug": slug.current,
        "primaryImage": primaryImage.media->,
        "socialImage": socialImage.media->,
        gallery[] {
          ...,
          _type == 'mediaReference' => @.media->,
        },
        narrative[] {
          ...,
          _type == 'mediaReference' => @.media->,
          markDefs[]{
            ...,
            _type == 'caseLink' => {
              "name": @.reference->name,
              "slug": @.reference->slug.current
            }
          }
        }
      }
    `;
  
  const params = { slug };
  const resp = await client.fetch(query, params);
  const preview = false;
  const data = filterDataToSingleItemForPreview(resp, preview);
  return { params, data, query};
};

export const getStateContent = async (slug, options = { preview: false }) => {
  const { preview } = options;

  const query = groq`
   *[_type == "state" && stateSlug.current == $slug  ]
    `;

  const params = { slug };
  const resp = await client.fetch(query, params);
  const data = filterDataToSingleItemForPreview(resp, preview);

  return { params, data, query, preview };
};
